import React from 'react'
import Widget, { WidgetLayout } from '@/components/stats/dashboard/widget'
import { StatNumber } from '@chakra-ui/react'
import DrilldownWidget from '../stats/dashboard/drilldown_widget'
import { ClickTrackingEventTypes } from '@/generated/enums'

export type NumberWidgetProps = {
  title: string
  helperText?: string
  infoContent?: string
  value: string | number
  loading?: boolean
  error?: any
  colSpan?: number
  drilldownData?: any
  clickTrackingEventName?: ClickTrackingEventTypes
}

const NumberWidget: React.FC<NumberWidgetProps> = ({
  title,
  helperText,
  infoContent,
  value,
  loading,
  error,
  colSpan = 6,
  drilldownData = null,
  ...props
}) => {
  const sharedWidgetProps = {
    colSpan,
    error,
    helpText: helperText,
    infoContent,
    label: title,
    layout: WidgetLayout.CONTENT_TOP,
    loading,
    rowSpan: 1,
    ...props,
  }

  const content = (
    <Widget {...sharedWidgetProps}>
      <StatNumber fontSize={32} lineHeight={1} mb={4} mt={1}>
        {value}
      </StatNumber>
    </Widget>
  )

  return drilldownData ? (
    <DrilldownWidget
      widgetProps={{
        title: sharedWidgetProps.label,
        helperText: sharedWidgetProps.helpText,
        drilldownData: drilldownData,
        value: value,
        clickTrackingEventName: props.clickTrackingEventName,
      }}
    >
      {content}
    </DrilldownWidget>
  ) : (
    content
  )
}

export default NumberWidget
